module.exports = __webpack_public_path__ + "static/v14-b9ad8542e47e4535d385e97145da41ed.jpg";